import React, { Fragment, useContext, useEffect, useState } from "react";
import { Grid, Typography, Breadcrumbs, Link } from "@material-ui/core";

// Contexts
import DiscountContext from "../../../context/discounts/DiscountContext";
import StoreContext from "../../../context/stores/StoreContext";
import LayoutContext from "../../../context/layout/LayoutContext";

// Components
import DiscountActions from "./DiscountActions";
import DiscountDisplay from "./DiscountDisplay";
import Unsave from "./confirmation/Unsave";

const DiscountHome = () => {
  const {
    default_form_data,
    display_content,
    discounts,
    selected_discount,
    form_data,
    setDisplayContent,
    getDiscounts,
    getDiscount,
    clearSelectedDiscount,
  } = useContext(DiscountContext);
  const { clearSearchStores } = useContext(StoreContext);
  const { clearAlerts } = useContext(LayoutContext);

  const [openUnsave, setOpenUnsave] = useState(false);
  const [confirmUnsave, setConfirmUnsave] = useState(false);
  const [changeToDiscount, setChangeToDiscount] = useState("");

  const fieldsValidation = (compare_data) => {
    let changes = false;

    for (let x in form_data) {
      if (x === "discount_include") {
        if (form_data[x].length !== compare_data[x].length) {
          changes = true;
        } else {
          form_data[x].map((each) => {
            if (!compare_data[x].includes(each)) {
              changes = true;
            }
          });
        }
      } else if (x === "discount_amount" || x === "spend_threshold") {
        if (parseFloat(form_data[x]) !== parseFloat(compare_data[x])) {
          changes = true;
          break;
        }
      } else if (x.includes("date")) {
        if (form_data[x] !== compare_data[x].slice(0, 10)) {
          changes = true;
        }
      } else if (form_data[x] !== compare_data[x]) {
        changes = true;
        break;
      }
    }

    return changes;
  };

  const onChangePage = (discount_name) => {
    setChangeToDiscount(discount_name);

    if (discount_name) {
      const current = selected_discount
        ? discount_name === selected_discount.discount_name
        : false;

      if (!current) {
        // onDiscount
        // Value Checking
        let changes = false;

        if (display_content === "Create")
          changes = fieldsValidation(default_form_data);
        if (display_content === "Edit")
          changes = fieldsValidation(selected_discount);

        if (changes) setOpenUnsave(true);
        else onDiscount(discount_name);
      }
    } else {
      // onCancel
      // Value Checking
      let changes = fieldsValidation(
        selected_discount ? selected_discount : default_form_data
      );

      if (changes) setOpenUnsave(true);
      else onCancel();
    }
  };

  const onDiscount = (discount_name) => {
    // Change Page - Discount Selected
    discount_name = discount_name ? discount_name : changeToDiscount;
    getDiscount(discount_name);
    setDisplayContent("Edit");
    changeUrl("onDiscount", `/discount/${discount_name}`);
    clearAlerts();
  };

  const onCancel = () => {
    // Change Page - No Discount Selected
    if (selected_discount) clearSelectedDiscount();
    setDisplayContent("");
    changeUrl("onCancel", "/discount");
    clearAlerts();
  };

  useEffect(() => {
    if (confirmUnsave) {
      if (changeToDiscount) onDiscount();
      else onCancel();
    }

    // Reset Variables
    setChangeToDiscount("");
    setOpenUnsave(false);
    setConfirmUnsave(false);
  }, [confirmUnsave]);

  const onPageLoad = () => {
    const paths = window.location.pathname.split("/");

    if (paths.length === 3) {
      if (paths[2] === "create") {
        setDisplayContent("Create");
        clearSelectedDiscount();
      } else {
        if (paths[2]) {
          getDiscount(paths[2]);
          setDisplayContent("Edit");
        }
      }
    } else setDisplayContent("");
  };

  useEffect(() => {
    getDiscounts();
    clearSearchStores();

    // Load Page When Back Button Triggered
    window.addEventListener("popstate", () => onPageLoad());

    // Load Page By Url
    if (!selected_discount) onPageLoad();
    // Load Page By Selected Discount
    else {
      if (display_content === "Edit" || display_content === "Create") {
        setDisplayContent("Edit");
        changeUrl("onLoad", `/discount/${selected_discount.discount_name}`);
      } else {
        setDisplayContent("");
        clearSelectedDiscount();
      }
    }
  }, [selected_discount]);

  const changeUrl = (action, path) => {
    // console.log(action, path);
    clearSearchStores();

    // Append "action" to URL Without Reload
    const html = document.getElementById("root").innerHTML;
    const pageTitle = document.title;
    const urlPath = window.location.origin + path;

    window.history.pushState(
      {
        html,
        pageTitle,
      },
      "",
      urlPath
    );
  };

  return (
    <Fragment>
      <Grid container direction="row" spacing={1}>
        {" "}
        {/* Breadcrumbs */}{" "}
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Discount </Typography>{" "}
          </Grid>
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              {" "}
              {selected_discount || display_content === "Create" ? (
                <Link color="inherit" href="/discount">
                  Discount{" "}
                </Link>
              ) : (
                <Link color="inherit"> Discount </Link>
              )}{" "}
              {selected_discount && (
                <Link color="inherit"> {selected_discount.discount_name} </Link>
              )}{" "}
              {display_content === "Create" && (
                <Link color="inherit"> {display_content} </Link>
              )}{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
        </Grid>
        {discounts && (
          <Fragment>
            <Unsave
              openUnsaveState={[openUnsave, setOpenUnsave]}
              setConfirmUnsave={setConfirmUnsave}
            />{" "}
            <DiscountActions
              fieldsValidation={fieldsValidation}
              onChangePage={onChangePage}
              changeUrl={changeUrl}
            />{" "}
            <DiscountDisplay onChangePage={onChangePage} />{" "}
          </Fragment>
        )}{" "}
      </Grid>{" "}
    </Fragment>
  );
};

export default DiscountHome;
